<template>
	<a
		class="secondary_site_button"
		:class="[theme, type]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink ? parsedLink.target : null"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="secondary_site_button"
	>

		<span v-html="button_label ? button_label : parsedLink.title"></span>

	</a>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		target: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.secondary_site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.secondary_site_button {
	display: inline-flex;
	padding: 0 16px;
	border-radius: 20px;
	text-decoration: none;
	height: 36px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	transition: 0.2s ease all;
	color: var(--duco-blue);
  border: 1px solid var(--grey);


	@media (hover) {
		&:hover {
			background: var(--white);
			transition: 0.2s ease all;
			cursor: pointer;

      span {
        color: var(--fpe-blue);
      }
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal normal 16px/24px var(--primary-font-family);
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
	}

	img {
		display: flex;
		max-width: 24px;
		max-height: 12px;
		margin-left: 8px;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SecondaryButton.vue